import { Box, Container, Typography } from '@mui/material';
import { UserManagement as UserManagementTemplate } from 'components/templates';
import React from 'react';

export const UserManagement = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'left' }}>
          Users
        </Typography>
      </Box>
      <UserManagementTemplate />
    </Container>
  );
};
